<div class="zn-form" [formGroup]="form">
  <fieldset>
    <div class="row">
      <div class="col-12">
        <div class="form-control-container">
          <label class="form-label" for="EucalyptusPercentage">
            {{ `${entityResource}::Entity.Cycle.EucalyptusPercentage` | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <input
            id="EucalyptusPercentage"
            class="form-control"
            type="number"
            formControlName="EucalyptusPercentage"
            min="0"
            max="1"
            step="0.01"
            inputmode="decimal"
            (keydown)="preventScientificNotation($event)"
            [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
          />
          @if (fieldInvalid('EucalyptusPercentage')) {
            @if (form.get('EucalyptusPercentage')?.hasError('required')) {
              <small class="invalid-feedback d-block">
                {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
              </small>
            }
            @if (form.get('EucalyptusPercentage')?.hasError('min') || form.get('EucalyptusPercentage')?.hasError('max')) {
              <small class="invalid-feedback d-block">
                {{ `${localizationResource}::ValueMustBeBetween` | abpLocalization : '0' : '1' }}
              </small>
            }
            @if (form.get('EucalyptusPercentage')?.hasError('maxDecimals')) {
              <small class="invalid-feedback d-block">
                {{ `${localizationResource}::InvalidDecimalScale` | abpLocalization : '2' }}
              </small>
            }
          }
        </div>
      </div>
    </div>
  </fieldset>
</div>
